<template>
    <div class="decorativeCom">
        <div :style="{
            'background': `url('${configImgUrl()}${config.borImg}')`,
        }"></div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/26 3:57 下午
     */
    import  configUrl from '@/assets/js/config';
    export default {
        name: 'borderComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {}
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .decorativeCom {
        > div {
            width: 100%;
            height: 100%;
            background-size: 100% 100% !important;
        }
    }
</style>
